export default "__VITE_PUBLIC_ASSET__b0afa1d5__"